import React, { useState, useRef } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Fix missing marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const LeafletMapPicker = ({ onSelect }) => {
  const defaultPosition = { lat: -34.9285, lng: 138.6007 }; // Adelaide
  const [markerPosition, setMarkerPosition] = useState(defaultPosition);
  const mapRef = useRef(null);

  const updatePosition = (latlng) => {
    setMarkerPosition(latlng);
    if (mapRef.current) {
      mapRef.current.setView([latlng.lat, latlng.lng], 13);
    }
    onSelect?.(latlng);
  };

  // Allow user to click map to move marker
  const MapClickHandler = () => {
    useMapEvents({
      click: (e) => updatePosition(e.latlng),
    });
    return null;
  };

  const handleUseCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        updatePosition({ lat: latitude, lng: longitude });
      },
      (err) => {
        console.warn('Geolocation error:', err);
        alert('Location access denied or unavailable.');
      },
      { enableHighAccuracy: true }
    );
  };

  return (
    <div>
      <MapContainer
        center={markerPosition}
        zoom={13}
        style={{ height: '400px', width: '100%', borderRadius: '1rem', marginBottom: '1rem' }}
        whenCreated={(map) => (mapRef.current = map)}
        scrollWheelZoom={true}
      >
        <MapClickHandler />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        <Marker
          position={markerPosition}
          draggable={true}
          eventHandlers={{
            dragend: (e) => {
              const newPos = e.target.getLatLng();
              updatePosition({ lat: newPos.lat, lng: newPos.lng });
            },
          }}
        />
      </MapContainer>

      <button className="btn-location" onClick={handleUseCurrentLocation}>
        📍 Use My Current Location
      </button>
    </div>
  );
};

export default LeafletMapPicker;
